@file:Suppress("MagicNumber", "TooManyFunctions")

package com.nonopn.skydome.common.app.pages.promocodes

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Switch
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.skydome.common.app.api.impl.AdminPromotionCode
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.promo_cancel
import com.nonopn.skywatcher.common.app.res.promo_err_code_invalid
import com.nonopn.skywatcher.common.app.res.promo_err_commission
import com.nonopn.skywatcher.common.app.res.promo_err_commission_email
import com.nonopn.skywatcher.common.app.res.promo_err_date_invalid
import com.nonopn.skywatcher.common.app.res.promo_err_date_past
import com.nonopn.skywatcher.common.app.res.promo_err_email
import com.nonopn.skywatcher.common.app.res.promo_err_fix_fields
import com.nonopn.skywatcher.common.app.res.promo_err_max
import com.nonopn.skywatcher.common.app.res.promo_err_months
import com.nonopn.skywatcher.common.app.res.promo_err_percent
import com.nonopn.skywatcher.common.app.res.promo_form_active
import com.nonopn.skywatcher.common.app.res.promo_form_app
import com.nonopn.skywatcher.common.app.res.promo_form_app_locked
import com.nonopn.skywatcher.common.app.res.promo_form_benefit
import com.nonopn.skywatcher.common.app.res.promo_form_benefit_both
import com.nonopn.skywatcher.common.app.res.promo_form_benefit_months
import com.nonopn.skywatcher.common.app.res.promo_form_benefit_percent
import com.nonopn.skywatcher.common.app.res.promo_form_code
import com.nonopn.skywatcher.common.app.res.promo_form_code_help
import com.nonopn.skywatcher.common.app.res.promo_form_commission
import com.nonopn.skywatcher.common.app.res.promo_form_commission_help
import com.nonopn.skywatcher.common.app.res.promo_form_end_date
import com.nonopn.skywatcher.common.app.res.promo_form_end_date_help
import com.nonopn.skywatcher.common.app.res.promo_form_end_date_none
import com.nonopn.skywatcher.common.app.res.promo_form_max
import com.nonopn.skywatcher.common.app.res.promo_form_max_unlimited
import com.nonopn.skywatcher.common.app.res.promo_form_months
import com.nonopn.skywatcher.common.app.res.promo_form_months_help
import com.nonopn.skywatcher.common.app.res.promo_form_percent
import com.nonopn.skywatcher.common.app.res.promo_form_percent_help
import com.nonopn.skywatcher.common.app.res.promo_form_percent_then
import com.nonopn.skywatcher.common.app.res.promo_form_preview
import com.nonopn.skywatcher.common.app.res.promo_form_preview_referrer
import com.nonopn.skywatcher.common.app.res.promo_referrer_locked
import com.nonopn.skywatcher.common.app.res.promo_form_referral
import com.nonopn.skywatcher.common.app.res.promo_form_referral_help
import com.nonopn.skywatcher.common.app.res.promo_form_referrer_email
import com.nonopn.skywatcher.common.app.res.promo_form_referrer_help
import com.nonopn.skywatcher.common.app.res.promo_form_rename_warning
import com.nonopn.skywatcher.common.app.res.promo_form_used_banner
import com.nonopn.skywatcher.common.app.res.promo_save
import com.nonopn.skywatcher.common.app.res.promo_save_error_network
import com.nonopn.skywatcher.common.app.res.promo_save_error_not_found
import com.nonopn.skywatcher.common.app.res.promo_save_error_server
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.compose.widgets.TextNormal
import eu.codlab.viewmodel.rememberViewModel
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

private val FormInk = Color(0xFF1A2433)
private val FormMuted = Color(0xFF5B6678)
private val FormChip = Color(0xFFE8EDF5)
private val FormDanger = Color(0xFFE63B2E)
private val FormWarning = Color(0xFFF28C28)

/** Apps a code can be created for (the app cannot be changed afterwards). */
private val PromoApps = listOf("StrikeRadar", "SkySentinel")

private fun fieldErrorMessage(error: PromoFieldError): StringResource? = when (error) {
    PromoFieldError.CodeInvalid -> Res.string.promo_err_code_invalid
    PromoFieldError.PercentRange -> Res.string.promo_err_percent
    PromoFieldError.FreeMonthsRange -> Res.string.promo_err_months
    PromoFieldError.MaxRedemptionsInvalid -> Res.string.promo_err_max
    PromoFieldError.EndDateInvalid -> Res.string.promo_err_date_invalid
    PromoFieldError.EndDateInPast -> Res.string.promo_err_date_past
    PromoFieldError.ReferrerEmailInvalid -> Res.string.promo_err_email
    PromoFieldError.CommissionRange -> Res.string.promo_err_commission
    PromoFieldError.CommissionRequiresEmail -> Res.string.promo_err_commission_email
    PromoFieldError.Server -> null
}

/**
 * Creation / modification of a promotion code (mock-up of 2026-11-02, section 3). One form for both; the POST
 * always sends the complete code. Errors are shown under each field (local checks, then conflicts of the server).
 */
@Suppress("LongMethod", "CyclomaticComplexMethod")
@Composable
fun PromoCodeEditScreen(
    modifier: Modifier,
    existing: AdminPromotionCode?,
    onDone: () -> Unit,
) {
    val appModel: AppModel = LocalApp.current
    val model = rememberViewModel { PromoCodeEditModel(appModel, existing) }
    val state by model.states.collectAsState()
    val form = state.form
    val validation = model.validation()
    // Referrer without email: the POST would erase the referral, so the save is blocked
    val locked = existing?.referrerLocked() == true

    LaunchedEffect(state.saved) {
        if (state.saved != null) onDone()
    }

    // Local errors once "Save" was pressed; a message of the server wins for its field
    val localMessages: Map<PromoField, String> = if (state.showErrors) {
        validation.errors.mapNotNull { (field, error) -> fieldErrorMessage(error)?.let { field to stringResource(it) } }
            .toMap()
    } else {
        emptyMap()
    }

    fun errorOf(field: PromoField): String? = state.serverErrors[field] ?: localMessages[field]

    Column(modifier = modifier.background(AppColor.StrikeBackground)) {
        Column(
            modifier = Modifier
                .weight(1f)
                .fillMaxWidth()
                .verticalScroll(rememberScrollState())
                .padding(16.dp)
                .widthIn(max = 720.dp),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            if (!form.isCreation && form.redemptions > 0) {
                Banner(stringResource(Res.string.promo_form_used_banner, form.redemptions), AppColor.StrikePrimary)
            }

            // App: chosen at the creation, locked afterwards
            Section(stringResource(Res.string.promo_form_app) + if (form.isCreation) " *" else "") {
                if (form.isCreation) {
                    ChoiceRow(PromoApps, form.app, { it }) { app -> model.edit(PromoField.App) { copy(app = app) } }
                } else {
                    TextNormal(text = "${form.app} 🔒", fontSize = 14.sp, fontWeight = FontWeight.SemiBold, color = FormInk)
                    Help(stringResource(Res.string.promo_form_app_locked))
                }
                errorOf(PromoField.App)?.let { ErrorText(it) }
            }

            Section(stringResource(Res.string.promo_form_code) + " *") {
                FormTextField(
                    value = form.code,
                    onChange = { text -> model.edit(PromoField.Code) { copy(code = normalizePromoCode(text)) } },
                    error = errorOf(PromoField.Code),
                    capitalization = KeyboardCapitalization.Characters,
                )
                Help(stringResource(Res.string.promo_form_code_help))
                if (form.isRenamed) {
                    Banner(
                        stringResource(Res.string.promo_form_rename_warning, form.originalCode.orEmpty(), normalizePromoCode(form.code)),
                        FormWarning
                    )
                }
            }

            Section(stringResource(Res.string.promo_form_benefit) + " *") {
                ChoiceRow(
                    PromoBenefitKind.entries,
                    form.benefitKind,
                    { kind ->
                        when (kind) {
                            PromoBenefitKind.Percent -> stringResource(Res.string.promo_form_benefit_percent)
                            PromoBenefitKind.FreeMonths -> stringResource(Res.string.promo_form_benefit_months)
                            PromoBenefitKind.Both -> stringResource(Res.string.promo_form_benefit_both)
                        }
                    }
                ) { kind -> model.edit(null) { copy(benefitKind = kind) } }
                if (form.benefitKind != PromoBenefitKind.Percent) {
                    Label(stringResource(Res.string.promo_form_months))
                    FormTextField(
                        value = form.freeMonths,
                        onChange = { model.edit(PromoField.FreeMonths) { copy(freeMonths = it.filter(Char::isDigit).take(3)) } },
                        error = errorOf(PromoField.FreeMonths),
                        keyboardType = KeyboardType.Number,
                    )
                    Help(stringResource(Res.string.promo_form_months_help))
                }
                if (form.benefitKind != PromoBenefitKind.FreeMonths) {
                    Label(
                        stringResource(
                            if (form.benefitKind == PromoBenefitKind.Both) {
                                Res.string.promo_form_percent_then
                            } else {
                                Res.string.promo_form_percent
                            }
                        )
                    )
                    FormTextField(
                        value = form.percentOff,
                        onChange = { model.edit(PromoField.PercentOff) { copy(percentOff = it.filter(Char::isDigit).take(3)) } },
                        error = errorOf(PromoField.PercentOff),
                        keyboardType = KeyboardType.Number,
                    )
                    Help(stringResource(Res.string.promo_form_percent_help))
                }
            }

            Section(stringResource(Res.string.promo_form_max)) {
                FormTextField(
                    value = form.maxRedemptions,
                    onChange = { model.edit(PromoField.MaxRedemptions) { copy(maxRedemptions = it.filter(Char::isDigit).take(9)) } },
                    error = errorOf(PromoField.MaxRedemptions),
                    placeholder = stringResource(Res.string.promo_form_max_unlimited),
                    keyboardType = KeyboardType.Number,
                )
            }

            Section(stringResource(Res.string.promo_form_end_date)) {
                FormTextField(
                    value = form.endDate,
                    onChange = { model.edit(PromoField.ValidUntil) { copy(endDate = it.take(10)) } },
                    error = errorOf(PromoField.ValidUntil),
                    placeholder = stringResource(Res.string.promo_form_end_date_none),
                    keyboardType = KeyboardType.Number,
                )
                Help(stringResource(Res.string.promo_form_end_date_help))
            }

            Section(null) {
                SwitchRow(stringResource(Res.string.promo_form_referral), form.referral) { checked ->
                    model.edit(PromoField.ReferrerEmail) { copy(referral = checked) }
                }
                Help(stringResource(Res.string.promo_form_referral_help))
                if (form.referral) {
                    Label(stringResource(Res.string.promo_form_referrer_email))
                    FormTextField(
                        value = form.referrerEmail,
                        onChange = { model.edit(PromoField.ReferrerEmail) { copy(referrerEmail = it.trim()) } },
                        error = errorOf(PromoField.ReferrerEmail),
                        keyboardType = KeyboardType.Email,
                    )
                    Help(stringResource(Res.string.promo_form_referrer_help))
                    Label(stringResource(Res.string.promo_form_commission))
                    FormTextField(
                        value = form.commissionPercent,
                        onChange = {
                            model.edit(PromoField.CommissionPercent) { copy(commissionPercent = it.filter(Char::isDigit).take(3)) }
                        },
                        error = errorOf(PromoField.CommissionPercent),
                        keyboardType = KeyboardType.Number,
                    )
                    Help(stringResource(Res.string.promo_form_commission_help))
                }
            }

            Section(null) {
                SwitchRow(stringResource(Res.string.promo_form_active), form.active) { checked ->
                    model.edit(null) { copy(active = checked) }
                }
            }
        }

        // Fixed bottom: preview of the code, messages and buttons (the form scrolls above)
        Column(
            modifier = Modifier.fillMaxWidth().background(Color.White).padding(horizontal = 16.dp, vertical = 10.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            val percent = if (form.benefitKind != PromoBenefitKind.FreeMonths) form.percentOff.toIntOrNull() else null
            val months = if (form.benefitKind != PromoBenefitKind.Percent) form.freeMonths.toIntOrNull() else null
            TextNormal(
                text = stringResource(Res.string.promo_form_preview, promoBenefitLabel(promoBenefit(percent, months))),
                fontSize = 13.sp,
                color = FormInk
            )
            val commission = form.commissionPercent.toIntOrNull()
            if (form.referral && form.referrerEmail.isNotBlank() && commission != null) {
                TextNormal(
                    text = stringResource(Res.string.promo_form_preview_referrer, form.referrerEmail.trim(), commission),
                    fontSize = 12.sp,
                    color = FormMuted
                )
            }
            if (locked) ErrorText(stringResource(Res.string.promo_referrer_locked))
            val failure = state.saveFailure
            when {
                failure != null -> ErrorText(
                    stringResource(
                        when (failure) {
                            PromoSaveFailure.NotFound -> Res.string.promo_save_error_not_found
                            PromoSaveFailure.Network -> Res.string.promo_save_error_network
                            PromoSaveFailure.Server -> Res.string.promo_save_error_server
                        }
                    ) + (state.serverMessage?.let { "\n$it" } ?: "")
                )
                (state.showErrors && !validation.isValid) || state.serverErrors.isNotEmpty() ->
                    ErrorText(stringResource(Res.string.promo_err_fix_fields))
            }
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Spacer(Modifier.weight(1f))
                TextNormal(
                    text = stringResource(Res.string.promo_cancel),
                    modifier = Modifier.clickable(enabled = !state.saving, onClick = onDone).padding(10.dp),
                    fontSize = 14.sp,
                    color = FormMuted
                )
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(10.dp))
                        .background(
                            if (state.saving || locked) AppColor.StrikePrimary.copy(alpha = 0.35f) else AppColor.StrikePrimary
                        )
                        .clickable(enabled = !state.saving && !locked) { model.save() }
                        .padding(horizontal = 18.dp, vertical = 10.dp),
                    contentAlignment = Alignment.Center
                ) {
                    if (state.saving) {
                        CircularProgressIndicator(modifier = Modifier.width(18.dp).height(18.dp), color = Color.White)
                    } else {
                        TextNormal(
                            text = stringResource(Res.string.promo_save),
                            fontSize = 14.sp,
                            fontWeight = FontWeight.Bold,
                            color = Color.White
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun Section(title: String?, content: @Composable () -> Unit) {
    Column(
        modifier = Modifier.fillMaxWidth().clip(RoundedCornerShape(12.dp)).background(Color.White).padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        title?.let { Label(it) }
        content()
    }
}

@Composable
private fun Label(text: String) {
    TextNormal(text = text, fontSize = 13.sp, fontWeight = FontWeight.SemiBold, color = FormInk)
}

@Composable
private fun Help(text: String) {
    TextNormal(text = text, fontSize = 11.sp, color = FormMuted)
}

@Composable
private fun ErrorText(text: String) {
    TextNormal(text = text, fontSize = 12.sp, color = FormDanger)
}

@Composable
private fun Banner(text: String, color: Color) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(10.dp))
            .background(color.copy(alpha = 0.12f))
            .padding(horizontal = 12.dp, vertical = 8.dp)
    ) {
        TextNormal(text = text, fontSize = 12.sp, color = FormInk)
    }
}

@Composable
private fun <T> ChoiceRow(choices: List<T>, selected: T, label: @Composable (T) -> String, onSelect: (T) -> Unit) {
    Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
        choices.forEach { choice ->
            val isSelected = choice == selected
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(16.dp))
                    .background(if (isSelected) AppColor.StrikePrimary else FormChip)
                    .clickable { onSelect(choice) }
                    .padding(horizontal = 12.dp, vertical = 6.dp)
            ) {
                TextNormal(
                    text = label(choice),
                    fontSize = 12.sp,
                    fontWeight = if (isSelected) FontWeight.SemiBold else FontWeight.Normal,
                    color = if (isSelected) Color.White else FormInk
                )
            }
        }
    }
}

@Composable
private fun SwitchRow(text: String, checked: Boolean, onChange: (Boolean) -> Unit) {
    Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
        TextNormal(text = text, modifier = Modifier.weight(1f), fontSize = 13.sp, fontWeight = FontWeight.SemiBold, color = FormInk)
        Switch(checked = checked, onCheckedChange = onChange)
    }
}

@Composable
private fun FormTextField(
    value: String,
    onChange: (String) -> Unit,
    error: String?,
    placeholder: String? = null,
    keyboardType: KeyboardType = KeyboardType.Text,
    capitalization: KeyboardCapitalization = KeyboardCapitalization.None,
) {
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        OutlinedTextField(
            modifier = Modifier.fillMaxWidth(),
            value = value,
            onValueChange = onChange,
            isError = error != null,
            singleLine = true,
            placeholder = if (placeholder != null) {
                { TextNormal(text = placeholder, fontSize = 13.sp, color = FormMuted) }
            } else {
                null
            },
            keyboardOptions = KeyboardOptions(capitalization = capitalization, keyboardType = keyboardType),
            shape = RoundedCornerShape(10.dp),
            colors = OutlinedTextFieldDefaults.colors(
                focusedContainerColor = Color.White,
                unfocusedContainerColor = Color.White,
                focusedTextColor = FormInk,
                unfocusedTextColor = FormInk,
                cursorColor = FormInk,
                focusedBorderColor = AppColor.StrikePrimary,
                unfocusedBorderColor = Color(0xFF8A94A6),
                errorBorderColor = FormDanger,
                errorContainerColor = Color.White,
                errorTextColor = FormInk,
            )
        )
        error?.let { ErrorText(it) }
    }
}
